module.exports = __webpack_public_path__ + "img/messenger-icon.bf28218.svg";